// notificacion.schema.ts

import * as yup from 'yup';

const DOMINIOS_PERMITIDOS = [
  'gmail.com',
  'hotmail.com',
  'outlook.com',
  'live.com',
  'yahoo.com',
  'fibramax.ec',
];

// correo: yup
//   .string()
//   .required('El correo es obligatorio')
//   .matches(
//     /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
//     'Debe ingresar un correo válido. Ejemplo: usuario@empresa.com'
//   ),

export const notificacionSchema = yup.object({
  notificacionId: yup.string().optional(),
  nombre: yup
    .string()
    .required('El nombre es obligatorio')
    .matches(/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/, 'Solo se permiten letras y espacios'),
  correo: yup
  .string()
  .required('El correo es obligatorio')
  .email('Debe ingresar un correo válido')
  .test(
    'dominio-permitido',
    `Solo se permiten correos con los dominios: ${DOMINIOS_PERMITIDOS.join(', ')}`,
    (value) => {
      if (!value) return false;

      // const dominiosPermitidos = [
      //   'gmail.com',
      //   'hotmail.com',
      //   'outlook.com',
      //   'live.com',
      //   'yahoo.com',
      //   'fibramax.ec',
      // ];

      const dominio = value.split('@')[1]?.toLowerCase();

      // return dominiosPermitidos.includes(dominio);
      return DOMINIOS_PERMITIDOS.includes(dominio);
    }
  ),
  estado: yup.boolean().required(),
});
